import H3CheckboxList from './h3-checkbox-list.vue'
import H3Checkbox from './h3-checkbox.vue'
import H3CheckboxItem from './h3-checkbox-item.vue'

H3Checkbox.List = H3CheckboxList
H3Checkbox.Item = H3CheckboxItem

H3Checkbox.install = (Vue) => {
  Vue.component(H3CheckboxList.name, H3CheckboxList)
  Vue.component(H3Checkbox.name, H3Checkbox)
  Vue.component(H3CheckboxItem.name, H3CheckboxItem)
}

export default H3Checkbox

export {
  H3CheckboxList,
  H3Checkbox,
  H3CheckboxItem
}
